import niceDate from "@/lib/nice-date";
import getAnyDescription from "@/lib/get-any-description";
import { getShortTitle, getTitle } from "@/lib/get-short-title";
import EventPicture from "@/components/EventPicture/EventPicture.vue";
import "./TeaserCard.sass";
import { appendCurrentParamsToURL } from "@/helpers/commonHelper";

export default {
  name: "eo-teaser-card",
  components: { EventPicture },
  props: {
    event: {
      type: Object,
      required: true
    },
    settings: {
      type: Object,
      required: true
    },
    targetUri: {
      type: String,
      required: true
    },
    isMobile: {
      type: Boolean,
      default: false
    },
    textColor: {
      type: String,
      default: "#333"
    }
  },
  data: () => ({
    showCopyrightInList: true
  }),
  computed: {
    title() {
      return getTitle(this.event);
    },
    shortTitle() {
      return getShortTitle(this.event);
    },
    description() {
      return getAnyDescription(this.event);
    },
    location() {
      if (this.event && this.settings) {
        if (this.event?.location?.length && this.event?.location[0]?.title) {
          let locationTitle = this.event.location[0].title;
          if (this.event.location[0].address) {
            let hasCity = false;
            if (
              this.settings.displayLocationCity &&
              this.event.location[0].address.city
            ) {
              locationTitle += ", " + this.event.location[0].address.city;
              hasCity = true;
            }
            if (
              this.settings.displayLocationDistrict &&
              this.event.location[0].address.district
            ) {
              locationTitle +=
                (hasCity ? "-" : "") + this.event.location[0].address.district;
            }
            if (
              this.settings.displayLocationCountry &&
              this.event.location[0].address.country
            ) {
              locationTitle += ", " + this.event.location[0].address.country;
            }
          }
          return locationTitle;
        }
        if (this.event.location_text) return this.event.location_text;
      }
      return "";
    },
    niceDate() {
      if (this.event && this.event.moment && this.event.moment.from) {
        return niceDate(this.event.moment.from, this.$i18n.locale);
      }
      return "";
    },
    niceTime() {
      if (this.event && this.event.moment && this.event.moment.from) {
        return niceDate(this.event.moment.from, this.$i18n.locale, true);
      }
      return "";
    },
    href() {
      if (this.targetUri) {
        // replace place holder strings with meaningful stuff
        let uri = this.targetUri.replace(/xxxSLUGxxx/, this.event.url_slug);

        if (this.event.moment) {
          uri = uri.replace(/xxxMOMENTxxx/, this.event.moment._id);
        } else {
          uri = uri.replace(/(\/)?xxxMOMENTxxx/, "");
        }

        return appendCurrentParamsToURL(uri);
      }
      return "";
    }
  },
  methods: {}
};
